import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(() => import('./BookCairLibraryPage'))

class AsyncBookCairLibraryPage extends AsyncPage {
  nonav = true
  constructor() {
    super({
      title: 'navigation./book-cair',
      pageComponent: component,
      isChromeless: true,
    })
  }
}

export default new AsyncBookCairLibraryPage()
